<template>
  <div :class="[$route.path === '/dashboard' ? 'justify-center' : 'mobile:justify-end laptop:justify-center']"
    class="relative text-center shadow-lg rounded-t-full z-10 flex items-center h-[40px] laptop:h-[50px] mt-4 mobile:pr-[30px] bg-customBlue-100">
    <p class="select-none tablet:mb-0 mobile:!mb-0 text-white mobile:text-[12px] laptop:text-sm font-roboto">
      Copyright © 2025 MyHappyHome | <a href="/contact-us" class="text-customYellow-100">Contact Us</a>
    </p>
  </div>
</template>

<script>
export default {
  // name: "FooterPartial",
};
</script>